import { memo } from 'react';

import FooterNav from '~/shared/components/footer/components/footer-nav';
import NextLink from '~/shared/components/link';
import SocialLinks from '~/shared/components/social-links/social-links';
import ThemedLogo from '~/shared/components/themed-logo';
import { type Locale, PAGE_NAMES } from '~/shared/constants';
import { getLocaleLink } from '~/shared/helpers/browser-helpers';

import './footer-menu.scss';

type FooterMenuProps = Readonly<{
  lng: Locale;
}>;

const FooterMenu = ({ lng }: FooterMenuProps) => {
  return (
    <div className="footer-menu">
      <div itemScope itemType="https://schema.org/Organization" className="footer-menu__menu-container">
        <NextLink itemProp="url" href={getLocaleLink(PAGE_NAMES.HOME, lng)} className="footer-menu__logo-link">
          <ThemedLogo itemProp="logo" alt="Prana Club logo" className="footer-menu__logo" />
        </NextLink>

        <FooterNav lng={lng} />
      </div>

      <div className="footer-menu__social-links">
        <SocialLinks showFullSet={true} />
      </div>
    </div>
  );
};

export default memo(FooterMenu);
